import * as firebase from 'firebase/app';
import { useAuthState } from 'react-firebase-hooks/auth';
import { useDocument } from 'react-firebase-hooks/firestore';
import { User, Profile } from 'models';

type UserProfile = User;

interface UseCurrentUserReturn {
  currentUser: UserProfile | void;
  loading: boolean;
  error: firebase.auth.Error | Error | void;
  auth: firebase.User | void;
}

function useCurrentUser(): UseCurrentUserReturn {
  const [auth, initialising, authError] = useAuthState(firebase.auth());
  const uid = auth && auth.uid;

  const userRef = uid
    ? firebase
        .firestore()
        .collection('users')
        .doc(uid)
    : undefined;
  const [userDoc, userLoading, userError] = useDocument(userRef);

  const profileRef = uid
    ? firebase
        .firestore()
        .collection('profiles')
        .doc(uid)
    : undefined;
  const [profileDoc, profileLoading, profileError] = useDocument(profileRef);

  let user;
  if (userDoc && userDoc.exists && auth && profileDoc && profileDoc.exists) {
    user = {
      ...(userDoc.data() as User),
      profile: profileDoc.data() as Profile
    };
  }

  return {
    currentUser: user,
    loading: initialising || userLoading || profileLoading,
    error: authError || userError || profileError,
    auth: auth
  };
}

export default useCurrentUser;
